import { useCallback, useState } from 'react';
import Masthead from '@/pages/home/components/Masthead';
import Hero from '@/pages/home/components/Hero';
import Ticker from '@/pages/home/components/Ticker';
import IndexNav from '@/pages/home/components/IndexNav';
import FeedSection from '@/pages/home/components/FeedSection';
import FeaturedTopics from '@/pages/home/components/FeaturedTopics';
import GuideIndex from '@/pages/home/components/GuideIndex';
import StatsOverview from '@/pages/home/components/StatsOverview';
import Subscribe from '@/pages/home/components/Subscribe';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  const [query, setQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('');

  const handleSelectCategory = useCallback((id: string) => {
    setActiveCategory((prev) => (prev === id ? '' : id));
    const target = document.getElementById('feed');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  const handleClearCategory = useCallback(() => setActiveCategory(''), []);
  const handleClearQuery = useCallback(() => setQuery(''), []);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <Masthead query={query} onQueryChange={setQuery} />
      <main>
        <Hero />
        <Ticker />
        <IndexNav active={activeCategory} onSelect={handleSelectCategory} />
        <FeedSection
          query={query}
          activeCategory={activeCategory}
          onClearCategory={handleClearCategory}
          onClearQuery={handleClearQuery}
        />
        <FeaturedTopics />
        <GuideIndex onSelectCategory={handleSelectCategory} />
        <StatsOverview />
        <Subscribe />
      </main>
      <SiteFooter />
    </div>
  );
}